/* eslint-disable react/display-name */
import { Redirect } from 'react-router';
import EndUserWrapper from './customer-management-wrapper';
import CustomerDetail from './customer-detail/customer-detail';

const CustomersConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/customer-management/customer-list',
      component: EndUserWrapper,
      title: 'Müşteri Listesi - Müşteri Yönetimi ',
      isAuthProtected: true
    },
    {
      path: '/customer-management/customer-contact-us',
      component: EndUserWrapper,
      title: 'Bize Ulaş - Müşteri Yönetimi',
      isAuthProtected: true
    },
    {
      path: [
        '/customer-management/:id/customer-detail',
        '/customer-management/:id/customer-agreements',
        '/customer-management/:id/customer-pharmacies',
        '/customer-management/:id/customer-orders'
      ],
      component: CustomerDetail,
      title: 'Müşteri Detay - Müşteri Yönetimi',
      isAuthProtected: true
    },
    {
      path: '/customer-management',
      component: () => <Redirect to="/customer-management/customer-list" />
    }
  ]
};

export default CustomersConfig;
